import React from 'react'
import Styled from 'styled-components'
import { lighten, darken } from 'polished'

import Icon from 'components/Icon'

const Controls = Styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
`

const Control = Styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.primary.shade400};
  color: ${props => props.theme.colors.white};
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.5rem;
  border-radius: ${props => props.theme.radius};
  transition: 300ms;
  cursor: pointer;

  &:hover {
    background-color: ${props => lighten(0.05, props.theme.colors.primary.shade400)};
  }

  &:active {
    background-color: ${props => darken(0.05, props.theme.colors.primary.shade400)};
  }

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    font-size: 1rem;
  }
`

export default ({ onEdit, onRemove, onMove, ...props }) => (
  <Controls {...props}>
    <Control onClick={onEdit}>
      <Icon liga="edit" />
    </Control>

    <Control onClick={onRemove}>
      <Icon liga="delete" />
    </Control>

    <Control onClick={() => onMove(-1)}>
      <Icon liga="arrow_upward" />
    </Control>

    <Control onClick={() => onMove(+1)}>
      <Icon liga="arrow_downward" />
    </Control>
  </Controls>
)



// WEBPACK FOOTER //
// ./src/components/PageComponentControls/index.js